export default __webpack_public_path__ + "708f5065ae715efccff5b0b6c130cc8c.png";